import { Sex, BloodType, IsDrinkType, IsSmokeType, isDrinkTypes, isSmokeTypes, bloodTypes, UserTypes, UserType } from "./abstract";
import { ICast } from "./cast";
// ユーザ情報(キャスト/ゲスト共通)
export interface IUserInfo {
    uid: string;
    userType: UserType;
    selfIntroDuction: string;
    imgSrcList: string[];
    name: string;
    sex: Sex;
    birthDate: string;
    age: string;
    prefecture: string;
    bloodType: BloodType;
    isDrink: IsDrinkType;
    isSmoke: IsSmokeType;
}

export const initUserInfo: IUserInfo = {
    uid: "",
    userType: UserTypes.None,
    selfIntroDuction: "",
    imgSrcList: [],
    name: "",
    sex: "",
    birthDate: "",
    age: "",
    prefecture: "",
    bloodType: bloodTypes.unknown,
    isDrink: isDrinkTypes.None,
    isSmoke: isSmokeTypes.None
}

// キャストのユーザー定義タイプガード
export function implementsCast(arg: any): arg is ICast{
    return arg !== null && typeof arg === "object" && arg.castType;
} 